import React, { ReactElement } from "react";
import styled, { css } from "styled-components";
import { media, spacing } from "../../theme";
import SectionList, { SectionTypes, SectionWithId } from "../SectionList";
import Content from "../../common/Content";
import {
  extractLinksFromSections,
  StickyNav,
  shortenNavLink
} from "./StickyNav";
import { slug } from "../../../lib/formatters";

const Wrapper = styled(Content)`
  position: relative;
  @media screen and ${media.mobile} {
    margin-top: 0%;
  }
`;
const Sidebar = styled(Content)`
  ${spacing("padding-bottom", 24)}
  width: initial;
  max-width: 320px;
  float: right;
  flex-direction: column;
  align-items: flex-end;
  @media screen and ${media.wide} {
    ${spacing("padding-left", 24)}
  }
  @media screen and ${media.desktop} {
    ${spacing("padding-left", 24)}
  }
  @media screen and ${media.tablet} {
    width: 100%;
    max-width: none;
    order: 999;
    align-items: flex-start;
  }
`;
const StyledContent = styled(Content)<{
  inline?: boolean;
}>`
  display: block;
  padding-top: 48px !important;

  @media screen and ${media.tablet} {
    display: flex;
    padding: calc(4px * 6) 0;
  }
`;
const StyledMain = styled.main`
  display: block;
  @media screen and ${media.desktop} {
    display: block;
  }
  @media screen and ${media.wide} {
    display: flex;
    > * {
      width: 100%;
    }
  }
`;

export function setIdFromNavLink(section: SectionWithNavLink) {
  section.id =
    section.navLink && (section.id || slug(shortenNavLink(section.navLink)));
}

export interface NestedSections {
  items?: {
    navLink?: string;
    items?: SectionTypes[];
  }[];
}
export function flattenCMSSectionLists(
  nestedSections: NestedSections
): SectionWithNavLink[] {
  if (!nestedSections || !nestedSections.items || !nestedSections.items.length)
    return null;
  const cmsSections = [];
  nestedSections.items.forEach(sectionList => {
    if (!sectionList.items || !sectionList.items.length) return;
    const sections = [...sectionList.items] as SectionWithNavLink[];
    sections[0].navLink = sectionList.navLink;
    cmsSections.push(...sections);
  });
  return cmsSections;
}

export type SectionWithNavLink = SectionWithId & {
  navLink?: string;
};
interface Props {
  sections: SectionWithNavLink[];
  noNavRender?: boolean;
  alwaysRenderSideBar?: boolean;
  className?: string;
  sidebar?: () => ReactElement;
  sidebarLabel?: string;
  limitContentWidth?: boolean;
}
export default function SectionListWithNav(props: Props) {
  const {
    noNavRender,
    className,
    alwaysRenderSideBar,
    limitContentWidth
  } = props;
  const sections = props.sections || [];
  if (
    (!alwaysRenderSideBar && !sections.length) ||
    (alwaysRenderSideBar && !props.sidebar && !sections.length)
  ) {
    return null;
  }
  sections.forEach(setIdFromNavLink);
  return (
    <Wrapper padded className={className}>
      {!noNavRender && (
        <StickyNav
          withSectionListWithNav
          links={extractLinksFromSections(sections)}
        />
      )}
      <StyledContent>
        {props.sidebar && (
          <Sidebar
            as="aside"
            leftIndented
            aria-label={props.sidebarLabel || "Mehr Infos"}
          >
            {props.sidebar()}
          </Sidebar>
        )}
        <StyledMain
        //limitContentWidth={limitContentWidth}
        //withSidebar={!!props.sidebar}
        >
          {sections && (
            <SectionList
              sections={sections}
              sectionProps={{
                leftIndented: true,
                fullWidth: true,
                noBackground: true,
                reducedSectionPadding: true
              }}
            />
          )}
        </StyledMain>
      </StyledContent>
    </Wrapper>
  );
}

SectionListWithNav.getImages = ({ sections }: Props) => {
  return SectionList.getImages({ sections });
};
